export enum AppEnum {
  TOAST_DANGER = 'danger',
  TOAST_WARN = 'Warning',
  STATUS_ACTIVE = 'ACTIVE',
  STATUS_CANCELED = 'CANCELLED',
  STATUS_MISSED = 'MISSED',
  STATUS_INCOMPLETE = 'INCOMPLETE',
  STATUS_COMPLETED = 'COMPLETED',
  STATUS_TOTAL = 'TOTAL',
  MENU_MEETING = 'Dashboard',
  MENU_ENQUIRIES = 'Enquiries',
  MENU_DOCUVAULT = 'Docu Vault',
  MENU_HOWTOUSE = 'How to use',
  MENU_FAQ = 'FAQ',
  MENU_LOGOUT = 'Logout',
  TOAST_SUCCCESS = 'success',
  DEALER = 'Dealer',
  CUSTOMER = 'Customer',
  APP_CHANNEL_ARENA = 'arena',
  APP_CHANNEL_NEXA = 'nexa',
  APP_CHANNEL_ARENA_VAL = 'NRM',
  APP_CHANNEL_NEXA_VAL = 'EXC',
  NW_ONLINE = 'Online',
  NW_OFFLINE = 'Offline',
  PLATFORM_IOS = 'iOS',
  PLATFORM_ANDROID = 'Android',
  PLATFORM_MACOS = 'macOS',
  PLATFORM_WINDOWS = 'Windows',
  PLATFORM_OTHER = 'Other',
}
